module.exports = __webpack_public_path__ + "assets/img/c8a6f6c16206de8c606adf70a8d3e310.png";